"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var react_1 = __importDefault(require("react"));
var FlexContainer_1 = require("../Containers/FlexContainer");
;
var Button = function (_a) {
    var children = _a.children, customClasses = _a.customClasses, _b = _a.variant, variant = _b === void 0 ? "default" : _b, _c = _a.accent, accent = _c === void 0 ? false : _c, onClick = _a.onClick, _d = _a.isSaving, isSaving = _d === void 0 ? false : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.type, type = _f === void 0 ? "button" : _f, form = _a.form;
    return (react_1.default.createElement("div", { className: "axxes-button__container" },
        react_1.default.createElement("button", { type: type, form: form, disabled: disabled || isSaving, className: "axxes-button".concat(variant === "default" ? "" : "--" + variant, " ").concat(accent ? "--color-accent" : "", " ").concat(disabled ? "--disabled" : "", " ").concat(isSaving ? "--loading" : "", " ").concat(customClasses || ""), onClick: onClick },
            react_1.default.createElement(FlexContainer_1.FlexContainer, { padding: "0" },
                isSaving && (react_1.default.createElement("div", { className: "spinner" },
                    react_1.default.createElement("div", { className: "bounce1" }),
                    react_1.default.createElement("div", { className: "bounce2" }),
                    react_1.default.createElement("div", { className: "bounce3" }))),
                !isSaving && react_1.default.createElement(react_1.default.Fragment, null, children)))));
};
exports.Button = Button;
